"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
// taken from https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_get
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const get = (obj, path, defaultValue = undefined) => {
    const travel = (regexp) => String.prototype.split
        .call(path, regexp)
        .filter(Boolean)
        .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
    const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
    return result === undefined || result === obj ? defaultValue : result;
};
exports.get = get;
//# sourceMappingURL=get.js.map